import React from 'react';
import { Link } from 'react-router-dom'
import { AppContext } from '../AppContext';
const About = (props) => {
    const app = React.useContext(AppContext);

    const isOnFacebook = app.platform === "FBInstant";
    const showMoreGames = app.marketPlace.hasGames();
    const showRateGame = !isOnFacebook;
    const rateGame = React.useCallback(() => {
        app.rateGame();
    }, []);
    const share = React.useCallback(() => {
        app.share();
    }, []);
    const email = React.useCallback(() => {
        app.email();
    }, []);

    return (<div id="About1" className="page1">
        <div className="wrapper">
            <div className="pageTitle">
                <a className="backButton" href="#"></a>
                <h1>About</h1>
            </div>
            {!isOnFacebook && (
                <div>
                    <a onClick={email} className="button buttonMail"   >
                        Send Feedback
                    </a>
                </div>
            )}
            {showRateGame && (
                <div>
                    <a onClick={rateGame} className="button buttonFavs" >
                        Rate Game
                    </a>
                </div>
            )}
            <div>
                <a onClick={share} className="button buttonShare"    >
                    Share
                </a>
            </div>
            {showMoreGames && (
                <div>
                    <a href="#MoreGames" className="button buttonGame"  >
                        More Games
                    </a>
                </div>
            )}
            <div style={{ textAlign: 'center' }} >
                gin@jdsoftwarellc.com
            </div>
        </div>
    </div>
    )
};

export default About;

